module.exports = "././assets/Images/admin_tenant.svg";